import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Row, Column} from "simple-flexbox";
import CustomInput from "../../common/components/CustomInput";
import CustomSelect from "../../common/components/CustomSelect";
import CustomButton from "../../common/components/CustomButton";
import {eventConstants} from "../../constants";
import Utility, {dispatchAction} from "../../utility";
import categoryService from "../../services/category";
import itemsService from "../../services/items";
import {connect} from "react-redux";
import {ThumbnailImg} from "../category/advertisersComponent";
import Dropzone from "react-dropzone";
import Utils from "../../utility";
import {getSignedURL, uploadFileToS3} from "../../managers/awsService";
import CustomTextArea from "../../common/components/CustomTextArea";
import {FormField, FormLabel} from "../../common/atoms/formElements";
import {UploadButton} from "../../common/atoms/styles";

const MainContainer = styled.div`
    text-align: left;
    margin: 20px;
    gap: 15px;
    display: flex;
    width: 100%;
    flex-direction: column;
`;

const Heading = styled.div`
    font-family: sans-serif !important;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.19;
    text-align: left;
    margin-bottom: 20px;
    color: #3a3a3a;
`;

export const InputColumn = styled(Column)`
    width: 50%;
    gap: 15px;
    font-size: 18px !important;

    span {
        margin-top: 5px;
        margin-bottom: 5px;
    }
`;
export const InputRow = styled(Row)`
    padding: 30px 20px;
    border: solid 1px #dfe1e6;
    border-radius: 6px;
    margin-right: 35px;
    background-color: #fafbfc;
    gap: 30px;
`;

const AddProductComponent = (props) => {
    const {isToUpdate, data, closeDialog} = props


    const [categoryList, setCategoryList] = useState([]);

    const [name, setName] = useState(data?.name || "");
    const [availableQuantity, setAvailableQuantity] = useState(data?.availableQuantity || "");
    const [weight, setWeight] = useState(data?.weight || "");
    const [keywords, setKeywords] = useState(data?.keywords?.join(",") || "");
    const [description, setDescription] = useState(data?.description || "");
    const [category, setCategory] = useState(false);
    const [gender, setGender] = useState(data?.gender || "WOMEN");
    const [metal, setMetal] = useState(data?.metal || "GOLD");
    const [purity, setPurity] = useState(data?.purity || "");
    const [media, setMedia] = useState(data?.media || "");
    const [isARSupported, setIsARSupported] = useState(data?.isARSupported ? 'YES' : 'NO');
    console.log("====keywords", keywords)
    const getCategoryList = async () => {
        props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(
            categoryService.getCategoryList(),
        );
        props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err) {
            Utility.apiFailureToast("Unable to fetch category");
        } else {
            setCategoryList(res);
            setCategory(isToUpdate ? data.category.id : res[0]._id);
        }
    }
    useEffect(() => {
        getCategoryList().then('Category Fetched')
    }, []);

    const onSubmitCategory = async () => {
        if (!media)
            return Utility.apiFailureToast("Image Required!");
        if (!name)
            return Utility.apiFailureToast("Name Required!");
        if (!weight)
            return Utility.apiFailureToast("Weight Required!");
        // if (!availableQuantity)
        //     return Utility.apiFailureToast("Available Quantity Required!");
        if (!purity)
            return Utility.apiFailureToast("Purity Required!");
        const reqData = {
            name,
            media,
            gender,
            purity,
            metal,
            keywords: keywords.split(",")?.map(data => data.trim()),
            availableQuantity,
            weight,
            description,
            isARSupported: isARSupported === 'YES',
        };
        const categoryData = categoryList.find((obj) => obj._id == category);
        reqData.category = {id: categoryData._id, name: categoryData.name};

        if (isToUpdate)
            reqData.itemId = data._id;

        props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(
            isToUpdate ? itemsService.updateItem(reqData) : itemsService.addItems(reqData),
        );
        props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err) return Utility.apiFailureToast(`Unable to ${isToUpdate ? "update" : "add"} Item`);
        Utility.apiSuccessToast(`Item ${isToUpdate ? "updated" : "added"} successfully`);
        // history.push(pathConstants.DASHBOARD_MENU.PRODUCTS);
        props.refreshList();
        if (isToUpdate)
            closeDialog()
    };
    const acceptanceString = ".jpg, .jpeg, .png, .svg";

    const onFileDrop = async (files) => {
        if (!files || files.length < 1) {
            Utils.apiFailureToast("Unable to find Media");
            return;
        }
        let file = files[0];
        let fileDetail = Utils.getFileName(file.name);
        let companyLogo = Utils.getNewFileName("category", fileDetail.extension);
        let resFromS3 = await uploadFileToS3(file, companyLogo, file.type).catch(
            (err) => {
                Utils.apiFailureToast("Unable to upload media");
                return false;
            },
        );
        let logoURL = await getSignedURL(companyLogo);
        if (!resFromS3 || !logoURL) {
            Utils.apiFailureToast("Unable to upload media");
            return false;
        }
        setMedia(companyLogo);
    };
    return (
        <MainContainer>
            <Heading>{isToUpdate ? "Update" : "Add"} Product</Heading>
            <InputRow>
                <InputColumn>
                    <FormField isMandatory={true} label='Item Name'>
                        <CustomInput
                            placeholder="Enter here"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Select Category'>
                        <CustomSelect
                            options={categoryList}
                            value={category}
                            onSelect={(e) => setCategory(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Metal'>
                        <CustomSelect
                            options={[
                                {_id: "GOLD", name: "Gold"},
                                {_id: "SILVER", name: "Silver"},
                            ]}
                            value={metal}
                            onSelect={(e) => setMetal(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Description'>
                        <CustomTextArea
                            placeholder="Description" value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={false} label='Keywords'>
                        <CustomInput
                            placeholder="Enter here - comma separated (necklace,men necklace)"
                            value={keywords}
                            onChange={(e) => setKeywords(e.target.value)}
                        />
                    </FormField>
                    <CustomButton text={isToUpdate ? "Update" : "Save"} onClick={onSubmitCategory}/>
                </InputColumn>
                <InputColumn>
                    <FormField isMandatory={true} label='Available Quantity'>
                        <CustomInput
                            placeholder="Enter here"
                            type={'number'}
                            value={availableQuantity}
                            onChange={(e) => setAvailableQuantity(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Gender'>
                        <CustomSelect
                            options={[
                                {_id: "WOMEN", name: "Women"},
                                {_id: "MEN", name: "Men"},
                            ]}
                            value={gender}
                            onSelect={(e) => setGender(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='MirAR supported?'>
                        <CustomSelect
                            options={[
                                {_id: "YES", name: "Yes"},
                                {_id: "NO", name: "No"},
                            ]}
                            value={isARSupported}
                            onSelect={(e) => setIsARSupported(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Purity'>
                        <CustomInput
                            placeholder="Enter here"
                            value={purity}
                            onChange={(e) => setPurity(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Weight'>
                        <CustomInput
                            placeholder="Enter here"
                            value={weight}
                            onChange={(e) => setWeight(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Thumbnail Image'>
                        <Dropzone
                            multiple={false}
                            accept={acceptanceString}
                            onDrop={(files) => onFileDrop(files)}
                            noClick={true}
                            onFileDialogCancel={() => setMedia(undefined)}
                        >
                            {({getRootProps, getInputProps, open}) => (
                                <div {...getRootProps()} className="outline-none">
                                    <input {...getInputProps()} />
                                    <UploadButton onClick={() => open()}>
                                        {media ? 'Change Item Image' : 'Upload Item Image'}
                                    </UploadButton>
                                </div>
                            )}
                        </Dropzone>
                    </FormField>
                    {media &&
                        <ThumbnailImg src={getSignedURL(media)}/>
                    }

                </InputColumn>
            </InputRow>
        </MainContainer>
    );
};

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(
    AddProductComponent,
);
